export default {
    feilopplysninger: {
        tittel: 'Personopplysningar om meg er feil – kva gjer eg?',
        melding: `<p>Dersom personopplysningar om deg er feil, kan du be om at dei vert retta. 
            Dersom personopplysningar er ufullstendige, kan du be om at dei blir supplert.
            I særlege tilfelle kan du ha rett til å få sletta personopplysningar om deg, men Nav har som regel ei
            lovbestemt plikt til å lagre opplysningane.</p>
            <p>Dersom personopplysningane er henta frå andre kjelder enn Nav, kan du ta kontakt med kjelda som er oppgitt.</p>
            <p>Dersom kjelda er Nav, kan du bruke <beskjedLenke>Send beskjed til Nav</beskjedLenke> eller ta kontakt med
            Nav Kontaktsenter, tlf. <telefonLenke>55 55 33 33</telefonLenke>.</p>`,
    },
    savneropplysninger: {
        tittel: 'Saknar du personopplysningar?',
        melding: `<p>Denne sida er under utvikling. Derfor er det ikkje sikkert du vil finne alle personopplysningar Nav har om deg her.
            Det kan være både tekniske og juridiske avgrensingar som gjer at vi ikkje kan vise personopplysningar. </p>
            <p>Saknar du personopplysningar eller lurer du på om Nav har fleire personopplysningar om deg,
            kan du bruke <beskjedLenke>Send beskjed til Nav</beskjedLenke>
            eller ta kontakt med Nav Kontaktsenter, tlf. <telefonLenke>55 55 33 33</telefonLenke>.</p>`,
    },
    utlevere: {
        tittel: 'Utlevere eller innhente opplysningar til/frå andre land',
        melding: `<p>Dersom du har budd eller arbeidd i andre land enn Norge, og har søkt om ytingar eller
            tenester i Norge eller i et annet land,  må Nav nokre gangar utveksle opplysningar om deg med trygdemyndigheitene i eit anna land.
            Nav vil berre levere ut opplysningar til land som er omfatta av EØS-avtalen eller land som Norge har inngått trygdeavtalar med. </p>
            <p><trygdeavtalerLenke>Sjå oversikt over kva land Norge har inngått trygdeavtale med</trygdeavtalerLenke></p>`,
    },
    klage: {
        tittel: 'Har du spørsmål eller ønsker du å klage?',
        melding: `<p>Dersom du har spørsmål om korleis vi behandlar personopplysningane dine, kan du bruke
            <beskjedLenke>Send beskjed til Nav</beskjedLenke>
            eller ta kontakt med Nav Kontaktsenter, tlf. <telefonLenke>55 55 33 33</telefonLenke>.</p>
            <p>Du har rett til å klage til Datatilsynet dersom du ikkje er nøgd med korleis vi behandlar personopplysningane dine, eller dersom du
            meiner behandlinga er i strid med personvernreglane. 
            Informasjon om korleis du går fram kan du finne på nettsidene til <datatilsynetLenke>Datatilsynet</datatilsynetLenke>. </p>
            <p>Vi oppmodar deg om å kontakte Nav før du klagar til Datatilsynet, slik at vi kan vurdere spørsmåla dine og informere
            deg om korleis vi behandlar personopplysningar.</p>`,
    },
    dsop: {
        info:
            'Her kan du laste ned ein logg med opplysningar Nav har gitt til forsikringsselskap eller pensjonsordningar. Nav kan utlevere opplysningar fordi du har gitt samtykke, eller fordi Nav har heimel i lov. Nav kan derfor ha delt fleire opplysningar enn dei du ser i denne loggen.' +
            '<br></br><br></br>' +
            'Du kan lese om kva opplysningar Nav kan utlevere i <a>personvernerklæringa til Nav</a>. Her kan du òg lese om korleis du tek kontakt med Nav viss du har spørsmål om rettane dine og personvern.',
    },
};
